import { z } from 'zod';

// src/enums.ts
var SystemRole = /* @__PURE__ */ ((SystemRole2) => {
  SystemRole2["ADMIN"] = "ADMIN";
  SystemRole2["FLEET_MANAGER"] = "FLEET_MANAGER";
  SystemRole2["USER"] = "USER";
  return SystemRole2;
})(SystemRole || {});
var PrincipalType = /* @__PURE__ */ ((PrincipalType2) => {
  PrincipalType2["USER"] = "USER";
  PrincipalType2["ENTRA_GROUP"] = "ENTRA_GROUP";
  return PrincipalType2;
})(PrincipalType || {});
var PermissionAction = /* @__PURE__ */ ((PermissionAction2) => {
  PermissionAction2["BOOK"] = "BOOK";
  PermissionAction2["APPROVE"] = "APPROVE";
  return PermissionAction2;
})(PermissionAction || {});
var PermissionEffect = /* @__PURE__ */ ((PermissionEffect2) => {
  PermissionEffect2["ALLOW"] = "ALLOW";
  PermissionEffect2["DENY"] = "DENY";
  return PermissionEffect2;
})(PermissionEffect || {});
var PRINCIPAL_TYPE_LABELS = {
  ["USER" /* USER */]: "Person",
  ["ENTRA_GROUP" /* ENTRA_GROUP */]: "Entra-Gruppe"
};
var PERMISSION_ACTION_LABELS = {
  ["BOOK" /* BOOK */]: "Buchen",
  ["APPROVE" /* APPROVE */]: "Freigeben"
};
var PERMISSION_EFFECT_LABELS = {
  ["ALLOW" /* ALLOW */]: "Erlauben",
  ["DENY" /* DENY */]: "Verbieten"
};
var ApprovalMode = /* @__PURE__ */ ((ApprovalMode2) => {
  ApprovalMode2["NONE"] = "NONE";
  ApprovalMode2["PRIVATE_ONLY"] = "PRIVATE_ONLY";
  ApprovalMode2["ALL"] = "ALL";
  return ApprovalMode2;
})(ApprovalMode || {});
var APPROVAL_MODE_LABELS = {
  ["NONE" /* NONE */]: "Ohne Freigabe",
  ["PRIVATE_ONLY" /* PRIVATE_ONLY */]: "Nur Privatfahrten",
  ["ALL" /* ALL */]: "Jede Buchung"
};
var TripType = /* @__PURE__ */ ((TripType2) => {
  TripType2["DIENSTLICH"] = "DIENSTLICH";
  TripType2["PRIVAT"] = "PRIVAT";
  TripType2["WOHNUNG_ERSTE_TAETIGKEITSSTAETTE"] = "WOHNUNG_ERSTE_TAETIGKEITSSTAETTE";
  TripType2["FAMILIENHEIMFAHRT"] = "FAMILIENHEIMFAHRT";
  return TripType2;
})(TripType || {});
var SELECTABLE_TRIP_TYPES = ["DIENSTLICH" /* DIENSTLICH */, "PRIVAT" /* PRIVAT */];
var TRIP_TYPE_LABELS = {
  ["DIENSTLICH" /* DIENSTLICH */]: "Dienstfahrt",
  ["PRIVAT" /* PRIVAT */]: "Privatfahrt",
  ["WOHNUNG_ERSTE_TAETIGKEITSSTAETTE" /* WOHNUNG_ERSTE_TAETIGKEITSSTAETTE */]: "Wohnung \u2194 erste T\xE4tigkeitsst\xE4tte",
  ["FAMILIENHEIMFAHRT" /* FAMILIENHEIMFAHRT */]: "Familienheimfahrt"
};
var BookingStatus = /* @__PURE__ */ ((BookingStatus2) => {
  BookingStatus2["PENDING_APPROVAL"] = "PENDING_APPROVAL";
  BookingStatus2["APPROVED"] = "APPROVED";
  BookingStatus2["IN_PROGRESS"] = "IN_PROGRESS";
  BookingStatus2["COMPLETED"] = "COMPLETED";
  BookingStatus2["REJECTED"] = "REJECTED";
  BookingStatus2["CANCELLED"] = "CANCELLED";
  return BookingStatus2;
})(BookingStatus || {});
var BOOKING_STATUS_LABELS = {
  ["PENDING_APPROVAL" /* PENDING_APPROVAL */]: "Wartet auf Freigabe",
  ["APPROVED" /* APPROVED */]: "Freigegeben",
  ["IN_PROGRESS" /* IN_PROGRESS */]: "L\xE4uft",
  ["COMPLETED" /* COMPLETED */]: "Abgeschlossen",
  ["REJECTED" /* REJECTED */]: "Abgelehnt",
  ["CANCELLED" /* CANCELLED */]: "Storniert"
};
var SLOT_BLOCKING_STATUSES = [
  "PENDING_APPROVAL" /* PENDING_APPROVAL */,
  "APPROVED" /* APPROVED */,
  "IN_PROGRESS" /* IN_PROGRESS */
];
var LogbookStatus = /* @__PURE__ */ ((LogbookStatus2) => {
  LogbookStatus2["ENTWURF"] = "ENTWURF";
  LogbookStatus2["FRIST_ABGELAUFEN"] = "FRIST_ABGELAUFEN";
  LogbookStatus2["FESTGESCHRIEBEN"] = "FESTGESCHRIEBEN";
  LogbookStatus2["STORNIERT"] = "STORNIERT";
  return LogbookStatus2;
})(LogbookStatus || {});
var OdometerSource = /* @__PURE__ */ ((OdometerSource2) => {
  OdometerSource2["OBD_OEM"] = "OBD_OEM";
  OdometerSource2["GNSS_TOTAL"] = "GNSS_TOTAL";
  OdometerSource2["TRIP_ODOMETER"] = "TRIP_ODOMETER";
  OdometerSource2["HAVERSINE"] = "HAVERSINE";
  return OdometerSource2;
})(OdometerSource || {});
var DataSource = /* @__PURE__ */ ((DataSource2) => {
  DataSource2["TELEMATIK_AUTO"] = "TELEMATIK_AUTO";
  DataSource2["MANUELL"] = "MANUELL";
  DataSource2["IMPORT"] = "IMPORT";
  return DataSource2;
})(DataSource || {});
var ActionChannel = /* @__PURE__ */ ((ActionChannel2) => {
  ActionChannel2["WEB"] = "WEB";
  ActionChannel2["SLACK"] = "SLACK";
  ActionChannel2["API"] = "API";
  ActionChannel2["SYSTEM"] = "SYSTEM";
  return ActionChannel2;
})(ActionChannel || {});
var ApprovalDecision = /* @__PURE__ */ ((ApprovalDecision2) => {
  ApprovalDecision2["APPROVED"] = "APPROVED";
  ApprovalDecision2["REJECTED"] = "REJECTED";
  return ApprovalDecision2;
})(ApprovalDecision || {});
var AuditOutcome = /* @__PURE__ */ ((AuditOutcome2) => {
  AuditOutcome2["SUCCESS"] = "SUCCESS";
  AuditOutcome2["DENIED"] = "DENIED";
  AuditOutcome2["ERROR"] = "ERROR";
  return AuditOutcome2;
})(AuditOutcome || {});
var DeviceStatus = /* @__PURE__ */ ((DeviceStatus2) => {
  DeviceStatus2["STOCK"] = "STOCK";
  DeviceStatus2["ACTIVE"] = "ACTIVE";
  DeviceStatus2["DEFECT"] = "DEFECT";
  DeviceStatus2["RETIRED"] = "RETIRED";
  return DeviceStatus2;
})(DeviceStatus || {});
var DEVICE_STATUS_LABELS = {
  ["STOCK" /* STOCK */]: "Lager",
  ["ACTIVE" /* ACTIVE */]: "Aktiv",
  ["DEFECT" /* DEFECT */]: "Defekt",
  ["RETIRED" /* RETIRED */]: "Ausgemustert"
};
var TripSource = /* @__PURE__ */ ((TripSource2) => {
  TripSource2["DEVICE_TRIP"] = "DEVICE_TRIP";
  TripSource2["DERIVED"] = "DERIVED";
  return TripSource2;
})(TripSource || {});
var TripQuality = /* @__PURE__ */ ((TripQuality2) => {
  TripQuality2["HIGH"] = "HIGH";
  TripQuality2["MEDIUM"] = "MEDIUM";
  TripQuality2["LOW"] = "LOW";
  return TripQuality2;
})(TripQuality || {});
var TripMatchStatus = /* @__PURE__ */ ((TripMatchStatus2) => {
  TripMatchStatus2["UNMATCHED"] = "UNMATCHED";
  TripMatchStatus2["AUTO_MATCHED"] = "AUTO_MATCHED";
  TripMatchStatus2["AMBIGUOUS"] = "AMBIGUOUS";
  TripMatchStatus2["MANUAL_MATCHED"] = "MANUAL_MATCHED";
  TripMatchStatus2["IGNORED"] = "IGNORED";
  return TripMatchStatus2;
})(TripMatchStatus || {});
var MatchSource = /* @__PURE__ */ ((MatchSource2) => {
  MatchSource2["AUTO"] = "AUTO";
  MatchSource2["MANUAL"] = "MANUAL";
  MatchSource2["SLACK"] = "SLACK";
  return MatchSource2;
})(MatchSource || {});
var GeocodeStatus = /* @__PURE__ */ ((GeocodeStatus2) => {
  GeocodeStatus2["PENDING"] = "PENDING";
  GeocodeStatus2["OK"] = "OK";
  GeocodeStatus2["FAILED"] = "FAILED";
  GeocodeStatus2["SKIPPED"] = "SKIPPED";
  return GeocodeStatus2;
})(GeocodeStatus || {});
var PropulsionType = /* @__PURE__ */ ((PropulsionType2) => {
  PropulsionType2["VERBRENNER"] = "VERBRENNER";
  PropulsionType2["BEV"] = "BEV";
  PropulsionType2["PHEV"] = "PHEV";
  return PropulsionType2;
})(PropulsionType || {});
var PROPULSION_TYPE_LABELS = {
  ["VERBRENNER" /* VERBRENNER */]: "Verbrenner",
  ["BEV" /* BEV */]: "Elektro",
  ["PHEV" /* PHEV */]: "Plug-in-Hybrid"
};
var ValuationMethod = /* @__PURE__ */ ((ValuationMethod2) => {
  ValuationMethod2["KEINE_PRIVATNUTZUNG"] = "KEINE_PRIVATNUTZUNG";
  ValuationMethod2["EIN_PROZENT"] = "EIN_PROZENT";
  ValuationMethod2["FAHRTENBUCH"] = "FAHRTENBUCH";
  return ValuationMethod2;
})(ValuationMethod || {});
var SlackLinkMethod = /* @__PURE__ */ ((SlackLinkMethod2) => {
  SlackLinkMethod2["SELF_SERVICE_SSO"] = "SELF_SERVICE_SSO";
  SlackLinkMethod2["EMAIL_LOOKUP"] = "EMAIL_LOOKUP";
  SlackLinkMethod2["ADMIN_MANUAL"] = "ADMIN_MANUAL";
  return SlackLinkMethod2;
})(SlackLinkMethod || {});

// src/booking-state.ts
var ALLOWED_TRANSITIONS = {
  ["PENDING_APPROVAL" /* PENDING_APPROVAL */]: [
    "APPROVED" /* APPROVED */,
    "REJECTED" /* REJECTED */,
    "CANCELLED" /* CANCELLED */
  ],
  ["APPROVED" /* APPROVED */]: [
    "IN_PROGRESS" /* IN_PROGRESS */,
    "CANCELLED" /* CANCELLED */,
    // Eine Freigabe zurückzunehmen ist kein Storno: Der Antragsteller soll
    // nachbessern können, statt neu buchen zu müssen.
    "REJECTED" /* REJECTED */
  ],
  ["IN_PROGRESS" /* IN_PROGRESS */]: ["COMPLETED" /* COMPLETED */, "CANCELLED" /* CANCELLED */],
  // Endzustände. Eine abgeschlossene Fahrt ist Grundlage des Fahrtenbuchs und
  // darf sich nicht rückwirkend in etwas anderes verwandeln.
  ["COMPLETED" /* COMPLETED */]: [],
  ["REJECTED" /* REJECTED */]: [],
  ["CANCELLED" /* CANCELLED */]: []
};
function canTransition(from, to) {
  return ALLOWED_TRANSITIONS[from].includes(to);
}
function isDecided(status) {
  return status !== "PENDING_APPROVAL" /* PENDING_APPROVAL */;
}

// src/time.ts
var SLOT_MINUTES = 15;
var SLOT_MS = SLOT_MINUTES * 60 * 1e3;
var PURPOSE_DEADLINE_DAYS = 7;
function isOnSlotBoundary(date) {
  return date.getTime() % SLOT_MS === 0;
}
function floorToSlot(date) {
  return new Date(Math.floor(date.getTime() / SLOT_MS) * SLOT_MS);
}
function ceilToSlot(date) {
  return new Date(Math.ceil(date.getTime() / SLOT_MS) * SLOT_MS);
}
function slotsBetween(start, end) {
  return (end.getTime() - start.getTime()) / SLOT_MS;
}
function purposeDeadline(tripEndedAt) {
  return new Date(tripEndedAt.getTime() + PURPOSE_DEADLINE_DAYS * 24 * 60 * 60 * 1e3);
}
function intervalsOverlap(aStart, aEnd, bStart, bEnd) {
  return aStart < bEnd && bStart < aEnd;
}
function getZonedParts(date, timeZone) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  }).formatToParts(date);
  const find = (type) => {
    const value = parts.find((p) => p.type === type)?.value;
    if (value === void 0) throw new Error(`Zeitkomponente ${type} nicht ermittelbar`);
    return Number(value);
  };
  const hour = find("hour");
  return {
    year: find("year"),
    month: find("month"),
    day: find("day"),
    hour: hour === 24 ? 0 : hour,
    minute: find("minute")
  };
}
function toZonedDateKey(date, timeZone) {
  const { year, month, day } = getZonedParts(date, timeZone);
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}
function minutesSinceLocalMidnight(date, timeZone) {
  const { hour, minute } = getZonedParts(date, timeZone);
  return hour * 60 + minute;
}

// src/errors.ts
var ApiErrorCode = {
  /** Zeitslot wurde zwischenzeitlich belegt (Postgres 23P01 aus dem EXCLUDE-Constraint) */
  BOOKING_SLOT_TAKEN: "BOOKING_SLOT_TAKEN",
  /** Zeitangabe liegt nicht auf einer Viertelstundengrenze */
  BOOKING_NOT_ON_SLOT_BOUNDARY: "BOOKING_NOT_ON_SLOT_BOUNDARY",
  BOOKING_INVALID_RANGE: "BOOKING_INVALID_RANGE",
  BOOKING_ALREADY_DECIDED: "BOOKING_ALREADY_DECIDED",
  /**
   * Eine freigegebene Buchung lässt sich nur verkürzen.
   *
   * Verlängern hieße, Zeit in Anspruch zu nehmen, über die niemand entschieden
   * hat — die Freigabe bezog sich auf den ursprünglichen Zeitraum. Dafür ist
   * eine neue Buchung der ehrlichere Weg.
   */
  BOOKING_CANNOT_EXTEND: "BOOKING_CANNOT_EXTEND",
  /** Status lässt keine Änderung der Zeiten mehr zu (abgeschlossen, storniert, abgelehnt) */
  BOOKING_NOT_EDITABLE: "BOOKING_NOT_EDITABLE",
  /**
   * Die Datenschutzhinweise wurden nicht oder in einer veralteten Fassung
   * bestätigt.
   *
   * Eigener Code, weil die Oberfläche darauf anders reagieren muss als auf einen
   * Eingabefehler: Sie muss den Hinweis in der **aktuellen** Fassung neu
   * anzeigen. Hat sich der Text geändert, während das Formular offen stand, ist
   * die alte Bestätigung wertlos — sie belegte einen anderen Text.
   */
  PRIVACY_NOTICE_NOT_ACKNOWLEDGED: "PRIVACY_NOTICE_NOT_ACKNOWLEDGED",
  NOT_ALLOWED_TO_BOOK_GROUP: "NOT_ALLOWED_TO_BOOK_GROUP",
  NOT_ALLOWED_TO_APPROVE_GROUP: "NOT_ALLOWED_TO_APPROVE_GROUP",
  SELF_APPROVAL_FORBIDDEN: "SELF_APPROVAL_FORBIDDEN",
  /** Weder Cache noch Stale-Kopie der Entra-Gruppen verfügbar — fail closed */
  GROUP_RESOLUTION_UNAVAILABLE: "GROUP_RESOLUTION_UNAVAILABLE",
  // ── Zugriff und Eingaben ────────────────────────────────────────────────────
  // Werden von Guards und Pipes geworfen und müssen in der Oberfläche
  // unterscheidbar sein: Eine fehlende Rolle ist kein Bedienfehler und braucht
  // einen anderen Hinweis als ein falsch ausgefülltes Feld.
  MISSING_ROLE: "MISSING_ROLE",
  MISSING_CAPABILITY: "MISSING_CAPABILITY",
  WRONG_PRINCIPAL_KIND: "WRONG_PRINCIPAL_KIND",
  VALIDATION_FAILED: "VALIDATION_FAILED",
  // ── Stammdaten ──────────────────────────────────────────────────────────────
  VEHICLE_NOT_FOUND: "VEHICLE_NOT_FOUND",
  VEHICLE_GROUP_NOT_FOUND: "VEHICLE_GROUP_NOT_FOUND",
  BOOKING_NOT_FOUND: "BOOKING_NOT_FOUND",
  /** Buchung trägt bereits Fahrten oder Fahrtenbucheinträge — nur noch stornierbar */
  BOOKING_HAS_RECORDS: "BOOKING_HAS_RECORDS",
  /** Verzeichnis nicht konfiguriert oder nicht erreichbar — nicht: keine Treffer */
  DIRECTORY_UNAVAILABLE: "DIRECTORY_UNAVAILABLE",
  // ── Ansicht als andere Person ───────────────────────────────────────────────
  /** Nur die Administration darf die Anwendung mit fremden Rechten ansehen. */
  IMPERSONATION_NOT_ALLOWED: "IMPERSONATION_NOT_ALLOWED",
  /**
   * In der fremden Ansicht wird nichts geschrieben.
   *
   * Sonst entstünden Buchungen, Freigaben und Stornierungen im Namen einer
   * Person, die nichts davon weiß — im Protokoll stünde ihr Name, und die
   * Angabe wäre schlicht falsch.
   */
  IMPERSONATION_READ_ONLY: "IMPERSONATION_READ_ONLY",
  /** Eintrag ist festgeschrieben, Änderung nur noch als Revision */
  LOGBOOK_ENTRY_LOCKED: "LOGBOOK_ENTRY_LOCKED",
  LOGBOOK_DEADLINE_PASSED: "LOGBOOK_DEADLINE_PASSED",
  LOGBOOK_VALIDATION_FAILED: "LOGBOOK_VALIDATION_FAILED",
  SLACK_ACCOUNT_NOT_LINKED: "SLACK_ACCOUNT_NOT_LINKED",
  /**
   * Das gewählte Slack-Konto gehört bereits zu einer anderen Person.
   *
   * Nicht auflösbar, ohne zu entscheiden, welche der beiden Zuordnungen falsch
   * ist — und das kann nur ein Mensch. Eigener Code, weil die Oberfläche hier
   * die andere Person benennen muss; ein allgemeiner Constraint-Fehler ließe
   * offen, welche gemeint ist.
   */
  SLACK_USER_ALREADY_LINKED: "SLACK_USER_ALREADY_LINKED",
  /** Slack ist nicht eingerichtet — Token oder Team-ID fehlen. */
  SLACK_NOT_CONFIGURED: "SLACK_NOT_CONFIGURED",
  /**
   * Der angegebene Channel taugt nicht — es gibt ihn nicht, er ist nicht
   * sichtbar, oder er ist über Slack Connect mit einer fremden Organisation
   * geteilt.
   *
   * Eigener Code, weil die Oberfläche hier auf das Feld zeigen muss, in dem die
   * Channel-ID steht, statt einen allgemeinen Konflikt zu melden.
   */
  SLACK_CHANNEL_UNUSABLE: "SLACK_CHANNEL_UNUSABLE",
  /** E-Mail ist nicht eingerichtet — SMTP-Host oder Absenderadresse fehlen. */
  MAIL_NOT_CONFIGURED: "MAIL_NOT_CONFIGURED",
  /**
   * Der eingegebene Empfänger passt zu keiner bekannten Form.
   *
   * Eigener Code, weil die Oberfläche hier aufzählen muss, was hineingehört —
   * eine Slack-ID und eine Mailadresse sehen einander nicht ähnlich genug, dass
   * ein allgemeiner Eingabefehler weiterhälfe.
   */
  RECIPIENT_NOT_RECOGNIZED: "RECIPIENT_NOT_RECOGNIZED",
  // ── Nutzerverwaltung ────────────────────────────────────────────────────────
  /**
   * Zu dieser Entra-Objekt-ID gibt es bereits einen Nutzer.
   *
   * Tritt auch dann auf, wenn sich die Person zwischen Auswahl und Anlegen zum
   * ersten Mal angemeldet hat — der Unique-Constraint entscheidet, und das ist
   * kein Fehler, sondern das gewünschte Ergebnis.
   */
  USER_ALREADY_EXISTS: "USER_ALREADY_EXISTS",
  USER_NOT_FOUND: "USER_NOT_FOUND",
  /** Die Objekt-ID ist im Verzeichnis nicht (mehr) auffindbar. */
  DIRECTORY_PRINCIPAL_NOT_FOUND: "DIRECTORY_PRINCIPAL_NOT_FOUND",
  // ── Telematik: Zuordnung Gerät → Fahrzeug ───────────────────────────────────
  DEVICE_NOT_FOUND: "DEVICE_NOT_FOUND",
  /**
   * Zeitraum überschneidet sich mit einer bestehenden Zuordnung (Postgres 23P01
   * aus dem EXCLUDE-Constraint, oder vorher aus der Prüfung).
   *
   * Betrifft beide Seiten: ein Gerät in zwei Fahrzeugen und ein Fahrzeug mit
   * zwei Geräten sind gleichermaßen unauflösbar — welche Fahrt dann wem
   * zufällt, entschiede die Sortierung.
   */
  DEVICE_ASSIGNMENT_OVERLAP: "DEVICE_ASSIGNMENT_OVERLAP",
  /**
   * Beginn liegt in der Zukunft.
   *
   * Eine Zuordnung, die erst morgen greift, erklärt die heute schon
   * eingegangenen Rohdaten nicht — und genau die will man zuordnen.
   */
  DEVICE_ASSIGNMENT_FUTURE: "DEVICE_ASSIGNMENT_FUTURE",
  /** Es gibt keine offene Zuordnung, die sich beenden ließe. */
  DEVICE_ASSIGNMENT_NOT_OPEN: "DEVICE_ASSIGNMENT_NOT_OPEN",
  /** Das Ende liegt vor dem Beginn. */
  DEVICE_ASSIGNMENT_INVALID_RANGE: "DEVICE_ASSIGNMENT_INVALID_RANGE",
  /** Für ein stillgelegtes Fahrzeug wird keine neue Zuordnung angelegt. */
  DEVICE_ASSIGNMENT_VEHICLE_INACTIVE: "DEVICE_ASSIGNMENT_VEHICLE_INACTIVE"
};

// src/privacy.ts
var CoordinatePrecision = /* @__PURE__ */ ((CoordinatePrecision2) => {
  CoordinatePrecision2["EXACT"] = "EXACT";
  CoordinatePrecision2["COARSE"] = "COARSE";
  CoordinatePrecision2["REMOVED"] = "REMOVED";
  return CoordinatePrecision2;
})(CoordinatePrecision || {});
var RawAnonymization = /* @__PURE__ */ ((RawAnonymization2) => {
  RawAnonymization2["NONE"] = "NONE";
  RawAnonymization2["COORDINATES_COARSENED"] = "COORDINATES_COARSENED";
  RawAnonymization2["COORDINATES_ZEROED"] = "COORDINATES_ZEROED";
  return RawAnonymization2;
})(RawAnonymization || {});
var RedactionReason = /* @__PURE__ */ ((RedactionReason2) => {
  RedactionReason2["PRIVATE_TRIP_ON_INGEST"] = "PRIVATE_TRIP_ON_INGEST";
  RedactionReason2["PRIVATE_TRIP_RECLASSIFIED"] = "PRIVATE_TRIP_RECLASSIFIED";
  RedactionReason2["DEADLINE_DEFAULTED_TO_PRIVATE"] = "DEADLINE_DEFAULTED_TO_PRIVATE";
  RedactionReason2["RETENTION_EXPIRED"] = "RETENTION_EXPIRED";
  RedactionReason2["DATA_SUBJECT_REQUEST"] = "DATA_SUBJECT_REQUEST";
  return RedactionReason2;
})(RedactionReason || {});
var DEFAULT_COARSE_DECIMALS = 1;
function coarsenCoordinate(coordinate, decimals = DEFAULT_COARSE_DECIMALS) {
  const factor = 10 ** decimals;
  return {
    latitude: Math.round(coordinate.latitude * factor) / factor,
    longitude: Math.round(coordinate.longitude * factor) / factor
  };
}
function coarseCellSizeMeters(decimals = DEFAULT_COARSE_DECIMALS) {
  return Math.round(111320 / 10 ** decimals);
}
function coarseUncertaintyRadiusMeters(decimals = DEFAULT_COARSE_DECIMALS) {
  return Math.round(coarseCellSizeMeters(decimals) * Math.SQRT1_2);
}
function requiresLocationRedaction(tripType) {
  return tripType === "PRIVAT";
}

// src/privacy-notice.ts
var PRIVACY_NOTICE_EDITION = "2026-08-18";
function policyTag(input) {
  return input.privateTripPolicy === "REMOVED" /* REMOVED */ ? "ohne-standort" : `raster-${coarseCellSizeMeters(input.coarseDecimals)}m`;
}
function formatKilometers(meters) {
  return `${(meters / 1e3).toFixed(1).replace(".", ",")} km`;
}
function privacyNoticeVersion(input) {
  return `${PRIVACY_NOTICE_EDITION}+${policyTag(input)}`;
}
function buildPrivacyNotice(input) {
  const coarse = input.privateTripPolicy === "COARSE" /* COARSE */;
  const cellSizeMeters = coarse ? coarseCellSizeMeters(input.coarseDecimals) : void 0;
  const uncertaintyRadiusMeters = coarse ? coarseUncertaintyRadiusMeters(input.coarseDecimals) : void 0;
  const sections = [
    {
      id: "daten",
      heading: "Was gespeichert wird",
      emphasis: true,
      paragraphs: [
        "Aus der Buchung: wer bucht, welches Fahrzeug, von wann bis wann und ob dienstlich oder privat. Bei dienstlichen Fahrten au\xDFerdem Zweck, Ziel und Mitfahrende.",
        "Aus dem Fahrzeug kommen dazu:"
      ],
      bullets: [
        "Beginn und Ende der Fahrt \u2014 Zeitpunkt und Ort",
        "Kilometerstand am Anfang und am Ende",
        "Tankstand am Anfang und am Ende"
      ]
    },
    {
      id: "nicht",
      heading: "Und was nicht",
      paragraphs: [
        "Der Weg zwischen Start und Ziel wird nicht aufgezeichnet. Es gibt keine laufende Ortung w\xE4hrend der Fahrt und keine Auswertung, wer wann wie lange unterwegs war."
      ]
    },
    {
      id: "privatfahrten",
      heading: "Bei Privatfahrten",
      emphasis: true,
      paragraphs: [
        "Zweck und Ziel werden gar nicht erst erfasst \u2014 die Felder erscheinen nicht, und die Datenbank w\xFCrde einen solchen Eintrag zur\xFCckweisen. Steuerlich z\xE4hlen bei einer Privatfahrt nur die Kilometer.",
        coarse ? `Start- und Endpunkt werden vergr\xF6bert: Die Koordinaten werden auf ein Raster von rund ${formatKilometers(cellSizeMeters)} gerundet. Der gespeicherte Ort kann damit bis zu rund ${formatKilometers(uncertaintyRadiusMeters)} vom tats\xE4chlichen abweichen.` : "Start- und Endpunkt werden nicht gespeichert. Die Koordinaten werden verworfen; \xFCbrig bleiben Zeitpunkt und gefahrene Strecke."
      ]
    },
    {
      id: "warum",
      heading: "Warum",
      paragraphs: [
        "Damit ein Fahrzeug nicht zweimal vergeben wird und man sehen kann, bei wem es gerade ist.",
        "Und f\xFCr das Fahrtenbuch: Damit weisen wir dem Finanzamt nach, dass die Fahrzeuge betrieblich genutzt werden. Daher die Kilometerst\xE4nde \u2014 ohne l\xFCckenlose Kette wird das Fahrtenbuch nicht anerkannt."
      ]
    },
    {
      id: "sichtbarkeit",
      heading: "Wer was sieht",
      paragraphs: [
        "Im Kalender sehen alle: Name, Fahrzeug, Zeitraum, ob die Buchung freigegeben ist und ob die Fahrt dienstlich oder privat ist. Bei dienstlichen Fahrten au\xDFerdem die Zeile \u201EIm Kalender sichtbar\u201C \u2014 sie ist beim Buchen mit dem Zweck vorbelegt und l\xE4sst sich vorher \xE4ndern. Was dort steht, entscheidest du.",
        "Zweck, Ziel, Mitfahrende und Notiz sehen nur du selbst und wer Buchungen dieser Fahrzeuggruppe freigeben darf."
      ]
    },
    {
      id: "fristen",
      heading: "Wie lange",
      paragraphs: [
        "Fahrtenbuchdaten zehn Jahre \u2014 das gibt die Abgabenordnung vor und l\xE4sst sich nicht verk\xFCrzen.",
        `Die technischen Rohdaten der Ger\xE4te werden nach ${input.rawRetentionDays} Tagen automatisch gel\xF6scht.`
      ]
    }
  ];
  return {
    version: privacyNoticeVersion(input),
    edition: PRIVACY_NOTICE_EDITION,
    anonymization: {
      policy: input.privateTripPolicy,
      cellSizeMeters,
      uncertaintyRadiusMeters
    },
    sections
  };
}
var SLACK_USER_ID_PATTERN = /^[UW][A-Z0-9]+$/;
var SLACK_CHANNEL_ID_PATTERN = /^[CGD][A-Z0-9]+$/;
var provisionUserSchema = z.object({
  entraObjectId: z.guid("Ung\xFCltige Entra-Objekt-ID")
});
var setSlackLinkSchema = z.object({
  slackUserId: z.string().trim().regex(SLACK_USER_ID_PATTERN, "Ung\xFCltige Slack-User-ID (erwartet wird z. B. U01ABC2DEF)").max(20, "Slack-User-ID ist zu lang")
});

// src/integration.ts
var RECIPIENT_HINT = "Erwartet wird eine Slack-ID (U\u2026 f\xFCr ein Konto, C\u2026 f\xFCr einen Channel) oder eine Mailadresse.";
function classifyRecipient(input) {
  const trimmed = input.trim();
  if (!trimmed) return void 0;
  if (trimmed.includes("@")) {
    return { kind: "EMAIL", address: trimmed.toLowerCase() };
  }
  const id = trimmed.toUpperCase();
  if (SLACK_USER_ID_PATTERN.test(id)) return { kind: "SLACK_USER", id };
  if (SLACK_CHANNEL_ID_PATTERN.test(id)) return { kind: "SLACK_CHANNEL", id };
  return void 0;
}

// src/notification-template.ts
var TEMPLATE_PLACEHOLDERS = [
  "kennzeichen",
  "fahrzeug",
  "fahrzeuggruppe",
  "beginn",
  "ende",
  "zeitraum",
  "buchungsnummer",
  "fahrtart",
  "kalendertext",
  "fahrer",
  "portal"
];
var NotificationTemplateEvent = /* @__PURE__ */ ((NotificationTemplateEvent2) => {
  NotificationTemplateEvent2["BOOKING_STARTED"] = "BOOKING_STARTED";
  NotificationTemplateEvent2["BOOKING_ENDED"] = "BOOKING_ENDED";
  return NotificationTemplateEvent2;
})(NotificationTemplateEvent || {});
var TEMPLATE_EVENT_LABELS = {
  ["BOOKING_STARTED" /* BOOKING_STARTED */]: "Wenn eine Buchung beginnt",
  ["BOOKING_ENDED" /* BOOKING_ENDED */]: "Wenn eine Buchung endet"
};
var TEMPLATE_DEFAULTS = {
  ["BOOKING_STARTED" /* BOOKING_STARTED */]: "Deine Buchung beginnt jetzt: {{kennzeichen}} ({{fahrzeug}}), {{zeitraum}}.\nBitte pr\xFCfe den Tankstand und melde Sch\xE4den, bevor du losf\xE4hrst.",
  ["BOOKING_ENDED" /* BOOKING_ENDED */]: "Deine Buchung ist beendet: {{kennzeichen}} ({{fahrzeug}}), {{zeitraum}}.\nDenk an den Kilometerstand und daran, den Schl\xFCssel zur\xFCckzubringen.\n{{portal}}"
};
var TEMPLATE_MAX_LENGTH = 1e3;
var PLACEHOLDER_PATTERN = /\{\{\s*([a-zA-Z_]+)\s*\}\}/g;
function renderTemplate(body, values) {
  return body.replace(PLACEHOLDER_PATTERN, (match, rawName) => {
    const name = rawName.toLowerCase();
    if (!TEMPLATE_PLACEHOLDERS.includes(name)) return match;
    return values[name] ?? "";
  });
}
function unknownPlaceholders(body) {
  const found = /* @__PURE__ */ new Set();
  for (const match of body.matchAll(PLACEHOLDER_PATTERN)) {
    const name = match[1]?.toLowerCase();
    if (name && !TEMPLATE_PLACEHOLDERS.includes(name)) {
      found.add(name);
    }
  }
  return [...found];
}
var TEMPLATE_SAMPLE = {
  kennzeichen: "M-XX 1234",
  fahrzeug: "Beispielwagen",
  fahrzeuggruppe: "Poolfahrzeuge",
  beginn: "Mo 12.10.2026, 09:00",
  ende: "Mo 12.10.2026, 17:00",
  zeitraum: "Mo 12.10.2026, 09:00 \u2013 17:00",
  buchungsnummer: "B-2026-0042",
  fahrtart: "Dienstfahrt",
  kalendertext: "Ausw\xE4rtstermin",
  fahrer: "Beispielperson",
  portal: "https://fuhrpark.example.org/bookings"
};
var MAX_BOOKING_DAYS = 30;
var PUBLIC_PURPOSE_MAX_LENGTH = 120;
var isoDate = z.coerce.date().refine((d) => !Number.isNaN(d.getTime()), {
  message: "Ung\xFCltiger Zeitpunkt"
});
var slotAligned = isoDate.refine(isOnSlotBoundary, {
  message: "Zeitangaben sind nur in 15-Minuten-Schritten m\xF6glich"
});
var createBookingSchema = z.object({
  vehicleId: z.guid(),
  /** Weggelassen = für sich selbst buchen. */
  driverId: z.guid().optional(),
  startsAt: slotAligned,
  endsAt: slotAligned,
  intendedTripType: z.enum(TripType).default("DIENSTLICH" /* DIENSTLICH */).refine(
    (v) => SELECTABLE_TRIP_TYPES.includes(v),
    {
      message: "Diese Fahrtart kann nicht selbst gebucht werden \u2014 bitte an die Fuhrparkleitung wenden"
    }
  ),
  purpose: z.string().trim().max(500).optional(),
  /** Kurztext für den geteilten Kalender, für alle sichtbar. */
  publicPurpose: z.string().trim().max(PUBLIC_PURPOSE_MAX_LENGTH).optional(),
  destinationAddress: z.string().trim().max(500).optional(),
  passengers: z.string().trim().max(500).optional(),
  notes: z.string().trim().max(2e3).optional(),
  /**
   * Bestätigte Fassung der Datenschutzhinweise.
   *
   * Hier bewusst nur optional und ohne inhaltliche Prüfung: **Ob** eine
   * Bestätigung nötig ist, hängt davon ab, ob der Buchende die betreffende
   * Fahrzeuggruppe freigeben darf — das weiß nur der Server. Und **welche**
   * Fassung gilt, hängt an der laufenden Konfiguration, die dieses Schema
   * ebenfalls nicht kennt. Beides prüft der BookingService.
   *
   * Kein `boolean`: Ein Häkchen belegt, dass jemand geklickt hat, eine
   * Version belegt, was dabei auf dem Schirm stand.
   */
  privacyNoticeVersion: z.string().trim().max(80).optional()
}).superRefine((data, ctx) => {
  if (data.endsAt <= data.startsAt) {
    ctx.addIssue({
      code: "custom",
      path: ["endsAt"],
      message: "Das Ende muss nach dem Beginn liegen"
    });
  }
  const days = (data.endsAt.getTime() - data.startsAt.getTime()) / (24 * 60 * 60 * 1e3);
  if (days > MAX_BOOKING_DAYS) {
    ctx.addIssue({
      code: "custom",
      path: ["endsAt"],
      message: `Eine Buchung darf h\xF6chstens ${MAX_BOOKING_DAYS} Tage umfassen`
    });
  }
  if (data.intendedTripType === "PRIVAT" /* PRIVAT */) {
    if (data.destinationAddress) {
      ctx.addIssue({
        code: "custom",
        path: ["destinationAddress"],
        message: "Bei Privatfahrten wird kein Ziel erfasst"
      });
    }
    if (data.purpose) {
      ctx.addIssue({
        code: "custom",
        path: ["purpose"],
        message: "Bei Privatfahrten wird kein Zweck erfasst"
      });
    }
    if (data.publicPurpose) {
      ctx.addIssue({
        code: "custom",
        path: ["publicPurpose"],
        message: "Bei Privatfahrten wird kein Zweck erfasst"
      });
    }
  } else if (!data.purpose) {
    ctx.addIssue({
      code: "custom",
      path: ["purpose"],
      message: "Bitte den Zweck der Fahrt angeben"
    });
  }
});
var updateBookingSchema = createBookingSchema;
var cancelBookingSchema = z.object({
  reason: z.string().trim().max(500).optional()
});
var rescheduleBookingSchema = z.object({
  startsAt: slotAligned,
  endsAt: slotAligned
}).superRefine((data, ctx) => {
  if (data.endsAt <= data.startsAt) {
    ctx.addIssue({
      code: "custom",
      path: ["endsAt"],
      message: "Das Ende muss nach dem Beginn liegen"
    });
  }
  const days = (data.endsAt.getTime() - data.startsAt.getTime()) / (24 * 60 * 60 * 1e3);
  if (days > MAX_BOOKING_DAYS) {
    ctx.addIssue({
      code: "custom",
      path: ["endsAt"],
      message: `Eine Buchung darf h\xF6chstens ${MAX_BOOKING_DAYS} Tage umfassen`
    });
  }
});
var decideBookingSchema = z.object({
  decision: z.enum(ApprovalDecision),
  comment: z.string().trim().max(500).optional()
}).superRefine((data, ctx) => {
  if (data.decision === "REJECTED" /* REJECTED */ && !data.comment) {
    ctx.addIssue({
      code: "custom",
      path: ["comment"],
      message: "Bei einer Ablehnung wird eine Begr\xFCndung ben\xF6tigt"
    });
  }
});
var availabilityQuerySchema = z.object({
  from: isoDate,
  to: isoDate,
  vehicleGroupId: z.guid().optional()
}).refine((d) => d.to > d.from, {
  path: ["to"],
  message: "Das Ende des Zeitraums muss nach dem Beginn liegen"
}).refine((d) => (d.to.getTime() - d.from.getTime()) / (24 * 60 * 60 * 1e3) <= 62, {
  path: ["to"],
  message: "Es k\xF6nnen h\xF6chstens 62 Tage auf einmal abgefragt werden"
});
var hexColor = z.string().regex(/^#[0-9a-fA-F]{6}$/, "Farbe muss als Hex-Wert angegeben werden, z. B. #3b82f6");
var vehicleGroupSchema = z.object({
  name: z.string().trim().min(2).max(100),
  description: z.string().trim().max(1e3).optional(),
  approvalMode: z.enum(ApprovalMode).default("ALL" /* ALL */),
  colorHex: hexColor.default("#3b82f6"),
  isActive: z.boolean().default(true)
});
var vehicleSchema = z.object({
  licensePlate: z.string().trim().min(2).max(15),
  displayName: z.string().trim().min(1).max(100),
  vehicleGroupId: z.guid(),
  make: z.string().trim().max(50).optional(),
  model: z.string().trim().max(50).optional(),
  vin: z.string().trim().length(17).regex(/^[A-HJ-NPR-Z0-9]{17}$/i, "Ung\xFCltige Fahrgestellnummer (I, O und Q sind nicht zul\xE4ssig)").optional(),
  seats: z.number().int().min(1).max(99).optional(),
  notes: z.string().trim().max(2e3).optional(),
  colorHex: hexColor.optional(),
  // Steuerliche Stammdaten
  // In Cent als Ganzzahl — int4 deckt gut 21 Mio. Euro ab und erspart
  // bigint-Serialisierung über die API-Grenze.
  grossListPriceCent: z.coerce.number().int().nonnegative().optional(),
  firstRegistrationDate: z.coerce.date().optional(),
  propulsionType: z.enum(PropulsionType).default("VERBRENNER" /* VERBRENNER */),
  co2GramsPerKm: z.number().int().min(0).max(1e3).optional(),
  electricRangeKm: z.number().int().min(0).max(2e3).optional(),
  privateUseAllowed: z.boolean().default(false),
  inServiceFrom: z.coerce.date(),
  inServiceTo: z.coerce.date().optional(),
  isActive: z.boolean().default(true)
}).superRefine((data, ctx) => {
  if (data.inServiceTo && data.inServiceTo <= data.inServiceFrom) {
    ctx.addIssue({
      code: "custom",
      path: ["inServiceTo"],
      message: "Das Ende der Nutzungsdauer muss nach dem Beginn liegen"
    });
  }
  if (data.privateUseAllowed && data.grossListPriceCent === void 0) {
    ctx.addIssue({
      code: "custom",
      path: ["grossListPriceCent"],
      message: "Wenn Privatfahrten erlaubt sind, wird der Bruttolistenpreis f\xFCr die Bewertung ben\xF6tigt"
    });
  }
});
var principalRefSchema = z.object({
  principalType: z.enum(PrincipalType),
  entraObjectId: z.guid(),
  displayName: z.string().trim().min(1).max(200)
});
var vehicleGroupPermissionSchema = principalRefSchema.extend({
  action: z.enum(PermissionAction),
  effect: z.enum(PermissionEffect).default("ALLOW" /* ALLOW */)
});
var setVehicleGroupPermissionsSchema = z.object({
  permissions: z.array(vehicleGroupPermissionSchema).max(200)
}).superRefine((data, ctx) => {
  const seen = /* @__PURE__ */ new Set();
  data.permissions.forEach((permission, index) => {
    const key = `${permission.action}:${permission.principalType}:${permission.entraObjectId}`;
    if (seen.has(key)) {
      ctx.addIssue({
        code: "custom",
        path: ["permissions", index, "entraObjectId"],
        message: "Dieser Eintrag existiert f\xFCr diese Aktion bereits"
      });
    }
    seen.add(key);
  });
});
var directorySearchSchema = z.object({
  q: z.string().trim().min(2).max(100),
  type: z.enum(PrincipalType).optional()
});
var slackConfigSchema = z.object({
  slackTeamId: z.string().trim().min(1),
  slackChannelId: z.string().trim().regex(
    SLACK_CHANNEL_ID_PATTERN,
    "Ung\xFCltige Slack-Channel-ID (erwartet wird z. B. C01ABC2DEF)"
  ),
  slackChannelNameCache: z.string().trim().max(100),
  approverSlackUserIds: z.array(z.string().regex(SLACK_USER_ID_PATTERN, "Ung\xFCltige Slack-User-ID")).max(50).default([]),
  approverSlackUserGroupIds: z.array(z.string().regex(/^S[A-Z0-9]+$/, "Ung\xFCltige Slack-Usergruppen-ID")).max(50).default([]),
  notifyOnNewBooking: z.boolean().default(true),
  notifyOnUnmatchedTrip: z.boolean().default(true),
  allowSlackApproval: z.boolean().default(true),
  allowSelfApproval: z.boolean().default(false)
});
var vehicleGroupSlackConfigSchema = slackConfigSchema.omit({
  slackTeamId: true,
  slackChannelNameCache: true
});
var createApiTokenSchema = z.object({
  name: z.string().trim().min(3).max(100),
  scopes: z.array(z.string().trim().min(1)).min(1).max(50),
  /** Pflicht — ein Token ohne Ablauf ist ein Token, das nie widerrufen wird. */
  expiresAt: z.coerce.date().refine((d) => d.getTime() > Date.now(), {
    message: "Das Ablaufdatum muss in der Zukunft liegen"
  })
});
var deviceRegistrationSchema = z.object({
  imei: z.string().trim().regex(/^\d{15}$/, "Eine IMEI hat 15 Ziffern"),
  model: z.string().trim().max(50).default("FMC003"),
  serialNumber: z.string().trim().max(50).optional(),
  firmware: z.string().trim().max(50).optional(),
  /** Nur ein aktives Gerät kommt durch den Handschlag. */
  status: z.enum(DeviceStatus).default("ACTIVE" /* ACTIVE */)
});
var deviceAssignmentSchema = z.object({
  vehicleId: z.guid(),
  validFrom: z.coerce.date(),
  note: z.string().trim().max(500).optional()
});
var deviceUnassignSchema = z.object({
  validTo: z.coerce.date(),
  note: z.string().trim().max(500).optional()
});
var slackTestSchema = z.object({
  recipient: z.string().trim().min(1).max(254).optional()
});
var emailTestSchema = z.object({
  recipient: z.email("Keine g\xFCltige Mailadresse").max(254).optional()
});
var notificationTemplateSchema = z.object({
  isEnabled: z.boolean(),
  body: z.string().trim().min(1, "Der Text darf nicht leer sein \u2014 zum Abschalten gibt es den Schalter").max(TEMPLATE_MAX_LENGTH, `H\xF6chstens ${TEMPLATE_MAX_LENGTH} Zeichen`)
}).superRefine((data, ctx) => {
  const unknown = unknownPlaceholders(data.body);
  if (unknown.length === 0) return;
  ctx.addIssue({
    code: "custom",
    path: ["body"],
    message: `Unbekannte Platzhalter: ${unknown.map((name) => `{{${name}}}`).join(", ")}. Absicht? Dann bitte ohne doppelte Klammern schreiben.`
  });
});

export { ALLOWED_TRANSITIONS, APPROVAL_MODE_LABELS, ActionChannel, ApiErrorCode, ApprovalDecision, ApprovalMode, AuditOutcome, BOOKING_STATUS_LABELS, BookingStatus, CoordinatePrecision, DEFAULT_COARSE_DECIMALS, DEVICE_STATUS_LABELS, DataSource, DeviceStatus, GeocodeStatus, LogbookStatus, MAX_BOOKING_DAYS, MatchSource, NotificationTemplateEvent, OdometerSource, PERMISSION_ACTION_LABELS, PERMISSION_EFFECT_LABELS, PRINCIPAL_TYPE_LABELS, PRIVACY_NOTICE_EDITION, PROPULSION_TYPE_LABELS, PUBLIC_PURPOSE_MAX_LENGTH, PURPOSE_DEADLINE_DAYS, PermissionAction, PermissionEffect, PrincipalType, PropulsionType, RECIPIENT_HINT, RawAnonymization, RedactionReason, SELECTABLE_TRIP_TYPES, SLACK_CHANNEL_ID_PATTERN, SLACK_USER_ID_PATTERN, SLOT_BLOCKING_STATUSES, SLOT_MINUTES, SLOT_MS, SlackLinkMethod, SystemRole, TEMPLATE_DEFAULTS, TEMPLATE_EVENT_LABELS, TEMPLATE_MAX_LENGTH, TEMPLATE_PLACEHOLDERS, TEMPLATE_SAMPLE, TRIP_TYPE_LABELS, TripMatchStatus, TripQuality, TripSource, TripType, ValuationMethod, availabilityQuerySchema, buildPrivacyNotice, canTransition, cancelBookingSchema, ceilToSlot, classifyRecipient, coarseCellSizeMeters, coarseUncertaintyRadiusMeters, coarsenCoordinate, createApiTokenSchema, createBookingSchema, decideBookingSchema, deviceAssignmentSchema, deviceRegistrationSchema, deviceUnassignSchema, directorySearchSchema, emailTestSchema, floorToSlot, formatKilometers, getZonedParts, intervalsOverlap, isDecided, isOnSlotBoundary, minutesSinceLocalMidnight, notificationTemplateSchema, principalRefSchema, privacyNoticeVersion, provisionUserSchema, purposeDeadline, renderTemplate, requiresLocationRedaction, rescheduleBookingSchema, setSlackLinkSchema, setVehicleGroupPermissionsSchema, slackConfigSchema, slackTestSchema, slotsBetween, toZonedDateKey, unknownPlaceholders, updateBookingSchema, vehicleGroupPermissionSchema, vehicleGroupSchema, vehicleGroupSlackConfigSchema, vehicleSchema };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map